export default __webpack_public_path__ + "static/SuisseIntl-Medium-20601d3279a4a2d4644fec9482599132.otf";